module.exports = __webpack_public_path__ + "static/bg3-d0a61e39ba327524e43df8b6d3385f7a.png";